/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Box, Grid, Skeleton, Typography} from '@mui/material';

import Avatar from '@jobseeker/lotus/components/Avatar';
import {Docs} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {Link, LabeledComponent, CheckboxLabel} from '../UtilityComponents';
import {Tooltip} from '@jobseeker/lotus/elements';
import type {AppState} from '@jobseeker/common-core/types';
import {useSelector} from 'react-redux';
import {getOldLink, formatSalaryInLacs} from '@jobseeker/lotus/utils';
import type {} from '@jobseeker/lotus/mui.types';
import jobDetailService from '@jobseeker/common-core/services/jobdetail.service';
import {useRouter} from 'next/router';
import {handleTracking} from '@jobseeker/common-core/utils';
import {IoPlayOutline} from 'react-icons/io5';
import Dialog from '@jobseeker/lotus/components/Dialog';
import {useEffect, useState} from 'react';
import {openUrl} from '@jobseeker/common-core/utils';
import {VersionVariants} from '@jobseeker/lotus/enums';

import {
  FieldEmptyState,
  LabeledValue,
  VideoPlayer,
} from '@jobseeker/lotus/components';
import {AudioPlayer} from '@jobseeker/lotus/components';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {IoIosInformationCircleOutline} from 'react-icons/io';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export const ApplyJobInternal = ({
  mode = 'edit',
  source = 'review-apply',
  refInfo,
  containerProps = {},
  ...props
}: any) => {
  const {profile, completeness, profileLoading, ...extra} = useSelector(
    (state: AppState) => state.user
  );
  const jobDetail = useSelector((state: AppState) => state.jobDetail);
  const isEdit = mode === 'edit';
  const redirectPath = refInfo
    ? `job/${jobDetail.id}/review-apply?ref=${refInfo}`
    : `job/${jobDetail.id}/review-apply`;
  const isLarge = useIsLargeDevice();

  const redirectURL = `${process.env.NEXT_PUBLIC_LOAD_CONFIG}/${redirectPath}`;
  const router = useRouter();
  const redirectTo = (url: string) => () => openUrl(url);
  const openPersonalEdit = redirectTo('/registration/addPersonalDetails');
  const [isPlayDialogOpen, setPlayDialogOpen] = useState(false);
  const [AssessmentQuestions, setAssessmentQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAssessmentSubmited, setIsAssessmentSubmited] = useState(false);
  // const [playerUrl, setPlayerUrl] = useState<string | null>('');
  const trackEdit = () => {
    handleTracking('ClickEditCnA', {
      event_category: 'Job',
      Origin: router.asPath,
      Source: 'JobDescription',
      CategoryId: jobDetail?.categoryId,
      JobId: jobDetail?.id,
      RecruiterId: jobDetail.recruiter?.recruiterId,
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
    });
  };

  const handlePlayClick = async () => {
    // await setVideoResumeUrl();
    setPlayDialogOpen(true);
  };

  useEffect(() => {
    setTimeout(() => {
      jobDetailService.getAssessmentDetail(jobDetail.id).then(resp => {
        setAssessmentQuestions(resp.data);
        setIsAssessmentSubmited(!!resp.submitedDate || !!resp.data?.length);
        setIsLoading(false);
      });
    }, 200);
  }, []);

  return (
    <>
      <Box
        p={2}
        pt={{xxs: 2, md: 0}}
        pb={isEdit ? 2 : {xxs: 2, md: 0}}
        {...containerProps}
      >
        <Box>
          <Grid
            container
            columnSpacing={{md: 3, lg: 6}}
            rowSpacing={{xxs: 1.5}}
          >
            <Grid
              item
              mb={isEdit ? 3 : 0}
              xxs={12}
              sm={6}
              md={isEdit ? 4 : 4}
              lg={isEdit ? 3 : 4}
            >
              <Box>
                <Typography
                  color="text.secondary"
                  variant="subtitle1"
                  component={'p'}
                  mb={2}
                >
                  Personal Details{' '}
                  {!!isEdit && (
                    <Link
                      target="_self"
                      onClick={trackEdit}
                      href={getOldLink(
                        `/registration/addPersonalDetails?profiletype=1&pd=pd&redirectto=${redirectURL}`
                      )}
                    >
                      (Edit)
                    </Link>
                  )}
                </Typography>

                <Box sx={{display: 'flex', gap: 1, mb: isEdit ? 0 : 1}}>
                  <Avatar
                    sx={{width: 60, height: 60}}
                    imgUrl={profile.picUrl}
                  />
                  <Box>
                    <Box display={'flex'} gap={0.5}>
                      <Typography
                        component={'p'}
                        sx={{wordBreak: 'break-all'}}
                        variant="subtitle2"
                      >
                        {profile.name}{' '}
                      </Typography>
                      {profile.videoPath || profile.audioPath ? (
                        <Box
                          sx={{
                            backgroundColor: 'secondary.dark',
                            color: 'secondary.contrastText',
                            borderRadius: 4,
                            height: 'fit-content',
                            px: 1,
                            py: 0.5,
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: 12,
                            gap: 0.5,
                            cursor: 'pointer',
                          }}
                          onClick={handlePlayClick}
                        >
                          <IoPlayOutline />
                          <Typography
                            variant="caption"
                            fontWeight={500}
                            lineHeight={0}
                          >
                            Play
                          </Typography>
                        </Box>
                      ) : (
                        <></>
                      )}
                    </Box>

                    <Typography component={'p'} variant="body2">
                      {profile.email}
                    </Typography>
                    <Typography component={'p'} variant="body2">
                      {profile.phone?.replace(/^0+/, '')}
                    </Typography>
                  </Box>
                </Box>

                {!profile.videoPath && !profile.audioPath && !!isEdit && (
                  <Tooltip
                    arrow
                    title={
                      <>
                        <Typography component={'p'} variant="subtitle2">
                          Create your Audio/Video Profile
                        </Typography>
                        <Typography variant="body3">
                          Get your profile highlighted right away by creating
                          your own video/Audio Profile for free.
                        </Typography>
                      </>
                    }
                  >
                    <Link
                      target="_self"
                      onClick={trackEdit}
                      href={getOldLink(
                        `/registration/addAudioVideoProfile?profiletype=1&ur=ur&redirectto=${redirectURL}`
                      )}
                    >
                      <Typography
                        sx={{mt: 1.5}}
                        component={'p'}
                        variant="subtitle2"
                      >
                        + Create Audio/Video Profile
                      </Typography>
                    </Link>
                  </Tooltip>
                )}
                {!!isEdit && (
                  <>
                    <LabeledComponent
                      mt={2}
                      title="Industry"
                      value={profile.industry?.name}
                    />
                    <LabeledComponent
                      title="Functional Area"
                      value={profile.functionalArea?.name}
                    />
                  </>
                )}
                <LabeledValue
                  mt={isEdit ? 2.5 : 0}
                  loading={profileLoading}
                  title="Experience"
                  value={
                    Array.isArray(profile?.professionalInfo) &&
                    profile.professionalInfo.length > 0 &&
                    profile.experienceYear === 0 &&
                    profile.experienceMonth === 0
                      ? ''
                      : `${
                          profile.experienceYear > 30
                            ? '30+'
                            : profile.experienceYear
                        } ${
                          profile?.experienceYear == 1 ? 'Year ' : 'Years '
                        } ${profile.experienceMonth} ${
                          profile?.experienceMonth == 1 ? 'Month ' : 'Months '
                        }`
                  }
                  emptyState={<FieldEmptyState onAddClick={openPersonalEdit} />}
                />
                <LabeledComponent
                  title="Notice Period"
                  value={
                    parseInt(profile?.noticePeriod || '0') === 7
                      ? 'Immediately Available'
                      : `${profile?.noticePeriod} ${
                          parseInt(profile?.noticePeriod || '0') > 1
                            ? 'Months'
                            : 'Month'
                        }`
                  }
                />
                <LabeledComponent
                  mt={source == 'after-apply' ? 1 : 2.5}
                  title="Location"
                  value={profile?.locations?.current?.name}
                />
                {!!isEdit && (
                  <>
                    <LabeledComponent
                      title="Preferred Location"
                      value={profile?.locations?.preferred
                        ?.map(info => info?.name)
                        .join(', ')}
                    />

                    <LabeledValue
                      loading={profileLoading}
                      mt={3}
                      title="Annual Current Salary"
                      value={
                        profile.currentSalary >= 0
                          ? profile.confidential
                            ? 'Confidential'
                            : formatSalaryInLacs(profile.currentSalary)
                          : ''
                      }
                      emptyState={
                        <FieldEmptyState onAddClick={openPersonalEdit} />
                      }
                    />

                    <LabeledValue
                      loading={profileLoading}
                      title="Expected Annual Salary"
                      value={
                        profile?.expectedSalary >= 0
                          ? profile.confidential
                            ? 'Confidential'
                            : formatSalaryInLacs(profile?.expectedSalary) +
                              (profile.negotiable ? ' (Negotiable)' : '')
                          : ''
                      }
                      emptyState={
                        <FieldEmptyState onAddClick={openPersonalEdit} />
                      }
                    />
                  </>
                )}
              </Box>
            </Grid>
            {!!isEdit && (
              <Grid
                item
                mb={3}
                xxs={12}
                sm={6}
                md={isEdit ? 4 : 4}
                lg={isEdit ? 3 : 4}
              >
                <Box>
                  <Typography
                    color="text.secondary"
                    variant="subtitle1"
                    component={'p'}
                    mb={2}
                  >
                    Resume{' '}
                    {!!isEdit && (
                      <Link
                        target="_self"
                        onClick={trackEdit}
                        href={getOldLink(
                          `/registration/addPersonalDetails?profiletype=1&ur=ur&redirectto=${redirectURL}`
                        )}
                      >
                        (Edit)
                      </Link>
                    )}
                  </Typography>
                  {profile?.resumePath && (
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid',
                        borderColor: '#F0F1EE',
                        borderRadius: 4,
                        overflow: 'hidden',
                        gap: 1.5,
                        pr: 2,
                        pl: 10,
                        py: 2,
                      }}
                    >
                      <Box
                        sx={{
                          background: '#F3F7FA',
                          p: 3,
                          width: 'fit-content',
                          display: 'flex',
                          position: 'absolute',
                          height: 150,
                          alignItems: 'center',
                          left: 0,
                        }}
                      >
                        <Image
                          src={Docs}
                          alt={'Logo'}
                          width={20}
                          height={20}
                          object-fit="cover"
                        />
                      </Box>
                      <Box>
                        <Typography variant="subtitle3" component={'p'}>
                          {profile.resumePath}
                        </Typography>
                        <Typography
                          variant="body3"
                          fontSize={{xxs: 10}}
                          component={'p'}
                        >
                          {`(Uploaded On: ${profile?.resumeUpdatedAt})`}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {isAppIimjobs && (
                    <Typography
                      color="text.secondary"
                      variant="subtitle1"
                      component={'p'}
                      mb={2}
                      mt={5}
                    >
                      Cover Letter{' '}
                      {!!isEdit && (
                        <Link
                          target="_self"
                          onClick={trackEdit}
                          href={getOldLink(
                            `/registration/addCoverLetterAndSkills?profiletype=1&ur=ur&redirectto=${redirectURL}`
                          )}
                        >
                          ({profile?.coverText ? 'Edit' : 'Add'})
                        </Link>
                      )}
                    </Typography>
                  )}
                  {!!profile?.coverText && (
                    <Box
                      sx={{
                        border: '1px solid #F0F1EE',
                        borderRadius: 2,
                        maxHeight: 120,
                        overflowX: 'hidden',
                        overflowY: 'scroll',
                        px: 1.5,
                        py: 1,
                        fontSize: 14,
                        scrollbarWidth: 'unset !important',
                        /* width */
                        '&::-webkit-scrollbar': {
                          width: '16px !important',
                          display: 'block !important',
                        },
                        /* Track */
                        '&::-webkit-scrollbar-track': {
                          boxShadow: 'none',
                          borderRadius: '10px',
                        },

                        /* Handle */
                        '&::-webkit-scrollbar-thumb': {
                          background: '#7E7E7E33',
                          borderRadius: '10px',
                          border: '5px solid transparent',
                          backgroundClip: 'content-box',
                        },

                        /* Handle on hover */
                        '&::-webkit-scrollbar-thumb:hover': {
                          background: '#7E7E7E33 !important',
                        },
                      }}
                      // ref={coverTextBody}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: profile?.coverText?.replace(
                            /\\r\\n/g,
                            '<br/>'
                          ) as string,
                        }}
                      ></div>
                    </Box>
                  )}
                  {profile?.coverText && (
                    <CheckboxLabel
                      variant={
                        process.env.NEXT_PUBLIC_APP_NAME === 'hirist'
                          ? VersionVariants.VERSION_HIRIST
                          : undefined
                      }
                      size={16}
                      onChange={(value: boolean) =>
                        props.onChange && props.onChange({attachCover: value})
                      }
                      defaultChecked={!!profile?.settings?.['coverLetter']}
                      label={
                        <Typography variant="body2">
                          Attach Cover Letter
                        </Typography>
                      }
                      sx={
                        process.env.NEXT_PUBLIC_APP_NAME === 'hirist'
                          ? {m: 1, ml: 0}
                          : {}
                      }
                    />
                  )}
                </Box>
              </Grid>
            )}
            <Grid
              item
              mb={isEdit ? 3 : 0}
              xxs={12}
              sm={6}
              md={isEdit ? 4 : 4}
              lg={isEdit ? 3 : 4}
            >
              <Box>
                <Typography
                  color="text.secondary"
                  variant="subtitle1"
                  component={'p'}
                  mb={2}
                >
                  Education{' '}
                  {!!isEdit && (
                    <Link
                      target="_self"
                      onClick={trackEdit}
                      href={getOldLink(
                        `/registration/addEducationalDetails?profiletype=1&ed=ed&redirectto=${redirectURL}`
                      )}
                    >
                      (
                      {profile?.educationInfo &&
                      Array.isArray(profile?.educationInfo.info)
                        ? 'Edit'
                        : 'Add'}
                      )
                    </Link>
                  )}
                </Typography>
                {profile?.educationInfo &&
                Array.isArray(profile?.educationInfo.info) ? (
                  profile?.educationInfo?.info?.map((info, index) => (
                    <LabeledComponent
                      key={`applyjob-internal-v2-${index}`}
                      invert
                      mt={0}
                      mb={2}
                      title={info?.institute}
                      value={[
                        `${info.degree} (${info?.courseType})`,
                        `${info?.batchFrom}-${
                          info?.batchTo ? info?.batchTo : 'Present'
                        }`,
                      ]}
                    />
                  ))
                ) : (
                  <>{!!isEdit && 'Add your educational details.'}</>
                )}
              </Box>
            </Grid>
            <Grid
              item
              mb={isEdit ? 3 : 0}
              xxs={12}
              sm={6}
              md={isEdit ? 4 : 4}
              lg={isEdit ? 3 : 4}
            >
              {!(
                Array.isArray(profile?.professionalInfo) &&
                profile?.professionalInfo?.length == 0 &&
                !isEdit
              ) && (
                <Box>
                  <Typography
                    color="text.secondary"
                    variant="subtitle1"
                    component={'p'}
                    mb={2}
                  >
                    Work Experience Details{' '}
                    {!!isEdit && (
                      <Link
                        target="_self"
                        onClick={trackEdit}
                        href={getOldLink(
                          `/registration/addWorkExperience?profiletype=1&pro=pro&redirectto=${redirectURL}`
                        )}
                      >
                        (
                        {Array.isArray(profile?.professionalInfo)
                          ? 'Edit'
                          : 'Add'}
                        )
                      </Link>
                    )}
                  </Typography>
                  {Array.isArray(profile?.professionalInfo) ? (
                    profile?.professionalInfo?.map((info, index) => (
                      <LabeledComponent
                        key={`internal-profession-${index}`}
                        invert
                        mt={0}
                        mb={2}
                        title={info.organization}
                        value={[
                          info?.designation,
                          `${info?.fromYear}-${
                            parseInt(info?.toYear || '0')
                              ? info?.toYear
                              : 'Present'
                          }`,
                        ]}
                      />
                    ))
                  ) : (
                    <>I do not have any prior work experience</>
                  )}
                </Box>
              )}
            </Grid>

            {jobDetail.assessmentFlags == 1 && isAssessmentSubmited ? (
              <Grid item xxs={12} mt={-2} width={'min-content'}>
                <Box sx={{borderTop: '1px solid #7E7E7E33'}} pt={2}>
                  <Typography fontSize={{xxs: 16, md: 18}} variant="subtitle1">
                    About your application:
                  </Typography>
                  <Box ml={0.5} sx={{wordBreak: 'break-all'}}>
                    {AssessmentQuestions?.length && !isLoading ? (
                      <>
                        {AssessmentQuestions.map(
                          (question: any, index: number) => (
                            <Box
                              mt={2}
                              key={`job-assessment-question-${index}`}
                            >
                              <Typography mb={1} variant="subtitle2">
                                {index + 1}. {question.question}
                              </Typography>
                              <Typography variant="body3" component={'div'}>
                                {(Array.isArray(question.userAnswer)
                                  ? question.userAnswer.join(', ')
                                  : question.userAnswer) || (
                                  <Box
                                    display={'flex'}
                                    gap={1}
                                    alignItems={'center'}
                                  >
                                    You have not answered this question{' '}
                                    <Tooltip title="This question wasn't marked mandatory.">
                                      <Box lineHeight={0}>
                                        <Box
                                          component={
                                            IoIosInformationCircleOutline
                                          }
                                        />
                                      </Box>
                                    </Tooltip>
                                  </Box>
                                )}
                              </Typography>
                            </Box>
                          )
                        )}
                      </>
                    ) : (
                      <>
                        {new Array(5).fill({}).map((_, i) => (
                          <Skeleton
                            key={`screening-ques-${i}`}
                            variant="rounded"
                            width={'100%'}
                            height={21}
                            sx={{m: 2}}
                          />
                        ))}
                      </>
                    )}
                  </Box>
                </Box>
              </Grid>
            ) : jobDetail.assessmentFlags == 1 && isLoading ? (
              <>
                {new Array(5).fill({}).map((_, i) => (
                  <Skeleton
                    key={`screening-ques-${i}`}
                    variant="rounded"
                    width={'100%'}
                    height={21}
                    sx={{m: 2}}
                  />
                ))}
              </>
            ) : (
              <></>
            )}
          </Grid>
        </Box>
      </Box>
      <Dialog
        variant={VersionVariants.VERSION_THREE}
        open={isPlayDialogOpen}
        title="Audio/Video Profile"
        sx={{
          '& .MuiDialog-paper': {
            minWidth: {xxs: 'calc(100vw - 32px)', md: 'fit-content'},
          },
        }}
        titleProps={{
          pt: 3,
        }}
        onClose={() => setPlayDialogOpen(false)}
        fullScreen={false}
        fullWidth={isLarge ? false : true}
      >
        <Box
          p={{xxs: 0, md: 2}}
          width={{xxs: '100%', md: 680}}
          height={{xxs: 300, md: 380}}
        >
          {profile.videoPath ? (
            <>
              <VideoPlayer url={profile.video?.path || profile.videoPath} />
            </>
          ) : profile.audioPath ? (
            <AudioPlayer url={profile.audio?.path || profile.audioPath} />
          ) : (
            <>Audio Video Profile not present</>
          )}
        </Box>
      </Dialog>
    </>
  );
};
